const removeClasses = (cardContentElementsAll, cardMediaElementsAll) => {
    for(let i=0; i<cardContentElementsAll.length; i++){
        /flex/g.test(cardContentElementsAll[i].classList) &&
            cardContentElementsAll[i].classList.remove("flex");
        
        /brightness/g.test(cardMediaElementsAll[i].classList) &&
            cardMediaElementsAll[i].classList.remove("brightness");
    }
}
  
const addClasses = (cardContentElementsAll, cardMediaElementsAll, index) => {
    cardContentElementsAll[index].classList.add("flex");
    cardMediaElementsAll[index].classList.add("brightness");
}

export const onHandleClasses = (index) => {
    const cardContentElementsAll = document.querySelectorAll(".card-content");
    const cardMediaElementsAll = document.querySelectorAll(".card-media");

    //un problemita por tener botones div dentro de un button
    if(index === "remove") 
        setTimeout(()=>(
        removeClasses(cardContentElementsAll, cardMediaElementsAll)
        ), 50);
    else {
        removeClasses(cardContentElementsAll, cardMediaElementsAll);
        addClasses(cardContentElementsAll, cardMediaElementsAll, index);
    }
}
